import { TicketSaleModel } from 'api-hooks/sale/ticket-sale';
import { Option } from 'baseui/select';
import { PreferenceFormSchema } from 'common/form-schema';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export const TicketSaleFlightAirlineFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    airlineId: Yup.string().default(''),
    date: Yup.date().default(new Date()),
    detail: Yup.string().default(''),
    preferenceId: Yup.string().default(''),
    route: Yup.string().default(''),
    time: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    checkInStatus: Yup.string().nullable().default(null),

    //additional information
    customId: Yup.string(),
    airlineName: Yup.string().default(''),
  });

export const TicketSaleFlightAddOnsFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    route: Yup.string().default(''),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const TicketSaleFlightGuestFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    ticket: Yup.string().default(''),
    guestId: Yup.string().default(''),
    preferences: Yup.array(PreferenceFormSchema()).default([]),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
    guestPreferences: Yup.array(PreferenceFormSchema()).default([]),
  });

export const TicketSaleFlightSaleFormSchema = () =>
  Yup.object({
    customId: Yup.string(),
    bookingCode: Yup.string().default(''),
    flightSaleAirlines: Yup.array(TicketSaleFlightAirlineFormSchema()).default(
      [],
    ),
    flightSaleAddOns: Yup.array(TicketSaleFlightAddOnsFormSchema()).default([]),
    flightSaleGuests: Yup.array(TicketSaleFlightGuestFormSchema()).default([]),

    subtotalAddOns: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    subtotalAirlines: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
  });

export const TicketSaleFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    adminId: Yup.string().default(''),
    operatorId: Yup.string().default(''),
    salesmanId: Yup.string().default(''),
    customerId: Yup.string().default(''),
    customerBillingId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    flightSales: Yup.array(TicketSaleFlightSaleFormSchema()).default([]),

    //additional information
    tempTransactionAt: Yup.date().default(new Date()),
    phone: Yup.string().default(''),
    address: Yup.string().default(''),
    number: Yup.string().default(''),
    customerStatus: Yup.string().default(''),
    hasDueReceivable: Yup.boolean().default(false),
    remainingTransactionQuota: Yup.number().nullable().default(null),
    isExceedingQuota: Yup.boolean().default(false),
  });

export type TicketSaleFormType = Yup.InferType<
  ReturnType<typeof TicketSaleFormSchema>
> & { ticketSale?: TicketSaleModel; customerBillingOptions: Option[] };

export type TicketSaleMethodType = ReturnType<
  typeof useForm<TicketSaleFormType>
>;

export type TicketSaleFlightSaleFormType = Yup.InferType<
  ReturnType<typeof TicketSaleFlightSaleFormSchema>
>;

export type TicketSaleFlightAirlineFormType = Yup.InferType<
  ReturnType<typeof TicketSaleFlightAirlineFormSchema>
>;

export type TicketSaleFlightAddOnsFormType = Yup.InferType<
  ReturnType<typeof TicketSaleFlightAddOnsFormSchema>
>;

export type TicketSaleFlightGuestFormType = Yup.InferType<
  ReturnType<typeof TicketSaleFlightGuestFormSchema>
>;
